"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeSearchPageBodyStyle = void 0;
var detectUserAgent_1 = require("./detectUserAgent");
var changeSearchPageBodyStyle = function (mobileResize, isMobilePostView) {
    if (mobileResize &&
        detectUserAgent_1.detectUserAgent() === 'Apple Safari' &&
        !isMobilePostView) {
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'unset';
    }
};
exports.changeSearchPageBodyStyle = changeSearchPageBodyStyle;
